import React from "react";
import { Modal } from "react-bootstrap";

import useEsTelefono from "../../../../utils/esTelefono";
import { montoBonito } from "../../../../utils/monto";
import "../enrollmentUpdates/styles.css";
import "./cursos.css";

export const CORTE_MOVIL = 760;

export const Chip: React.FC<{ tono?: "acento" | "oro" | ""; children: React.ReactNode }> = ({ tono = "", children }) => (
	<span className={"wcuChip " + tono}>{children}</span>
);

export const Dato: React.FC<{ t: string; ancho?: boolean; children: React.ReactNode }> = ({ t, ancho, children }) => (
	<div className={"wcuDato" + (ancho ? " ancho" : "")}><small>{t}</small><div>{children}</div></div>
);

export const Seccion: React.FC<{ t?: React.ReactNode; acciones?: React.ReactNode; children: React.ReactNode }> = ({ t, acciones, children }) => (
	<div className="wcuSeccion">
		{t || acciones ? <div className="wcuSecCab"><h6>{t}</h6><div>{acciones}</div></div> : null}
		{children}
	</div>
);

/** Ventana grande de las pantallas de Cursos (la misma forma de Matrículas y Promociones). */
export const Ventana: React.FC<{ titulo: React.ReactNode; onClose: () => void; busy?: boolean; pie?: React.ReactNode; xl?: boolean; children: React.ReactNode }> = ({ titulo, onClose, busy, pie, xl, children }) => {
	const movil = useEsTelefono(CORTE_MOVIL);
	return (
		<Modal className="waModulo wcuVentana" show onHide={busy ? undefined : onClose} size={xl ? "xl" : "lg"} centered scrollable fullscreen="sm-down">
			<Modal.Header closeButton={!busy}>
				<Modal.Title style={{ fontSize: movil ? 15 : 18, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>{titulo}</Modal.Title>
			</Modal.Header>
			<Modal.Body style={{ textAlign: "left", fontSize: 15, paddingLeft: movil ? 14 : 22, paddingRight: movil ? 14 : 22 }}>{children}</Modal.Body>
			{pie ? <Modal.Footer className="wcuPie">{pie}</Modal.Footer> : null}
		</Modal>
	);
};

export const monto = (simbolo: string, v: number | null | undefined): string => `${simbolo}${montoBonito(v)}`;

/** Maestra con el nombre que se usa en pantalla. */
export const nombreMaestra = (m: any): string =>
	String(m?.nombre_mostrar || [m?.first_name, m?.last_name].filter(Boolean).join(" ") || m?.email || "").trim();

export const claveTab = (k: string) => "wcuTab_" + k;
